/* Mobile shortcut returns to the original personalizer. It never submits a cart form. */
(() => {
  if (customElements.get('product-purchase-bar')) return;
  const visible = element => !!element && element.getClientRects().length > 0;
  class ProductPurchaseBar extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.root = document.getElementById('MainProduct-' + this.dataset.sectionId);
      if (!this.root) return;
      this.mobile = matchMedia('(max-width: 749px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('[data-purchase-return]').addEventListener('click', () => this.returnToForm(), {signal: this.controller.signal});
      this.mobile.addEventListener('change', () => this.reconcile(), {signal: this.controller.signal});
      this.intersection = new IntersectionObserver(() => this.syncVisibility());
      this.mutations = new MutationObserver(() => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.reconcile(); });
      });
      this.mutations.observe(this.root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'], characterData: true});
      this.reconcile();
    }
    reconcile() {
      const buttons = ['#teeAtcButton', '#customily-cart-btn', '.product-form__submit'].flatMap(selector => [...this.root.querySelectorAll(selector)]);
      const button = buttons.find(visible);
      if (button !== this.mainButton) {
        this.intersection.disconnect();
        this.mainButton = button;
        if (button) this.intersection.observe(button);
      }
      // App/native variant changes update the original price; don't invent a second calculation.
      const price = this.root.querySelector('[id^="price-"]');
      const teePrice = this.root.querySelector('.tee-price--current');
      const currentPrice = visible(teePrice) ? teePrice : price?.querySelector('.flex > div');
      const copy = currentPrice?.textContent.trim();
      const destination = this.querySelector('[data-purchase-price]');
      if (copy && destination.textContent !== copy) destination.textContent = copy;
      this.syncVisibility();
    }
    syncVisibility() {
      this.hidden = !this.mobile.matches || !visible(this.mainButton) || this.mainButton.getBoundingClientRect().bottom > 0;
    }
    returnToForm() {
      const target = [
        ...['.tee-customization-wrapper', '#customily-options', 'variant-radios', 'variant-selects'].map(selector => this.root.querySelector(selector)),
        this.mainButton,
      ].find(visible);
      if (!target) return;
      const header = document.querySelector('[id$="__header"]');
      const offset = Math.min(header?.getBoundingClientRect().height || 0, 160) + 20;
      window.scrollTo({top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset), behavior: this.motion.matches ? 'auto' : 'smooth'});
      // Focus the region, not an input: no keyboard popup or changed personalization value.
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.intersection?.disconnect();
      this.mutations?.disconnect();
      cancelAnimationFrame(this.frame);
      this.controller = null;
    }
  }
  customElements.define('product-purchase-bar', ProductPurchaseBar);
})();
